import ProductStyle from "./ProductStyle.component";

export default ProductStyle;
